<script lang="ts">
    import { changeToNightIcon, formatRain, formatSnow, makeDate } from "../../Util/utils";
    export let weather;
    let currentPage:number = 0;
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let perPage = 8;
    let maxPages = 5;
    let displayUnits = Xert._displayUnits;
    //perPage*maxPages = 40, we get 40 forecasts from the api


    function formatTime(date){
        let hour = date.getHours();
        let postFix = " am";
        if(hour >= 12)
            postFix = " pm";
        if(hour > 12){
            hour -= 12;
        }
        if(hour == 0){
            hour += 12;
        }
        let result = `${hour} ${postFix}`;
        return result;
    }

    $: data = Array.from({length: 8}).map((_,index)=>weather.forecasts?.[currentPage*perPage + index] ?? {success: false})

</script>

{#if weather !== null}
    <div class="weather-table">
        <div class="page-item prev col-auto" class:invisible={currentPage == 0} on:click={() => {currentPage--}}><a href="#" id="prev-day" class="page-link"><i class="fa fa-angle-left fa-2xl" aria-hidden="true"></i></a></div>
        <div class="main-table">
            <table class="table table-striped table-hover table-bordered dt-responsive" width="100%" id="activities">
                <thead>
                </thead>
                <tbody class="text-center">
                    <tr>
                        <th></th>
                        {#each data as w, index(index)}
                            <th class="text-center">
                                {#if w.success}
                                {weekdays[makeDate(w.time).getDay()]} {months[makeDate(w.time).getMonth()]} {makeDate(w.time).getDate()}
                                <br>
                                {formatTime(makeDate(w.time))}
                                {/if}
                            </th>
                        {/each}
                    </tr>
                    <tr>
                        <th></th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                <img width="40" height="40" class="weather-icon" src="/assets/images/weather-{changeToNightIcon(w.icon_key, w.time, weather.sunrise, weather.sunset)}.svg">
                                {Math.round(w.temp)}&deg;{displayUnits == "imperial" ? "F" : "C"}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                    <tr class="wind">
                        <th class="text-center">Wind</th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                <img class="wind-icon" src="/assets/images/weather-wind-{w.wind.icon_key}.svg">
                                &nbsp;&nbsp;{Math.round(w.wind.speed)}{displayUnits == "imperial" ? "mph" : "kph"}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                    
                    <tr>
                        <th class="text-center">Gust</th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                {Math.round(w.wind.gust)}{displayUnits == "imperial" ? "mph" : "kph"}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                    <tr>
                        <th class="text-center">Feels like</th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                {Math.round(w.feels_like)}&deg;{displayUnits == "imperial" ? "F" : "C"}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                    <tr>
                        <th class="text-center">POP</th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                {Math.round(w.pop*100)}%
                                {/if}
                            </td>
                        {/each}
                    </tr>
                    <tr>
                        <th class="text-center">Rain</th>
                        {#each data as w, index(index)}
                        <td>
                            {#if w.success}
                            {formatRain(w.rain)}
                            {/if}
                        </td>
                        {/each}
                    </tr>
                    <tr>
                        <th class="text-center">Snow</th>
                        {#each data as w, index(index)}
                            <td>
                                {#if w.success}
                                {formatSnow(w.snow)}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="page-item next col-auto" class:invisible={currentPage == maxPages - 1} on:click={() => {currentPage++}}><a href="#" id="next-day" class="page-link"><i class="fa fa-angle-right fa-2xl" aria-hidden="true"></i></a></div>    
    </div>
{:else}
    Loading weather data...
{/if}


<style lang="scss">

    .wind-icon {
        transform: scale(1.5);
    }
    
    .weather-table {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .page-item > a {
        color: var(--color-xert-gray);
    }

    .page-item > a:hover {
        opacity: 0.8;
    }

    .page-item {
        width: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .main-table {
        width: 90%;
    }
</style>